import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  { path: '*',
    name: 'OTHERS',
    redirect: '/404',
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/login',
    name: 'LOGIN',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/forgot_password',
    name: 'FORGOT_PASSWORD',
    component: () => import('@/views/login/forgot_password'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/verify_token',
    name: 'VERIFY_TOKEN',
    component: () => import('@/views/login/verify_token'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  {
    path: '/verify_social_oauth',
    name: 'VERIFY_SOCIAL_AUTH',
    component: () => import('@/views/login/verify_social_oauth'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/',
    name: 'APPOINTMENTSTATUS',
    component: () => import('@/views/dashboard/appointmentStatus'),
    hidden: true,
    meta: { group: 'PAYROLL' }
  },
  {
    path: '/dashboard/:status',
    name: 'payroll',
    component: Layout,
    redirect: '/dashboard',
    meta: { group: 'PAYROLL' },
    hidden: true,
    children: [{
      path: '/dashboard/:status',
      component: () => import('@/views/dashboard/index'),
      meta: { title: 'Dashboard', group: 'PAYROLL', icon: 'tachometer-alt' }
    }]
  },
  {
    path: '/personnel',
    component: Layout,
    redirect: '/active-personnel',
    name: 'Personnels',
    meta: { title: 'Personnel', group: 'PAYROLLREPORT', icon: 'users' },
    children: [{
      path: '/active-personnel',
      name: 'Details',
      component: () => import('@/views/payroll/personnel/index'),
      meta: { title: 'Details', group: 'PAYROLL', icon: 'users' }
    },
    // {
    //   path: '/casual-number-of-days',
    //   name: 'CasualNumberOfDays',
    //   component: () => import('@/views/payroll/personnel/CasualNumDays'),
    //   meta: { title: 'Casual # of days', group: 'PAYROLL', icon: 'file-invoice' }
    // },
    {
      path: '/personnel-fundsource',
      name: 'Fund Source',
      component: () => import('@/views/payroll/fundsource/index'),
      meta: { title: 'Fund Source', group: 'BUDGET', icon: 'money-check' }
    }
    ]
  },
  {
    path: '/general/payroll',
    component: Layout,
    name: 'GENERAL PAYROLL',
    redirect: '/general/payroll/personnel-deduction',
    meta: {
      title: 'General Payroll',
      icon: 'file-invoice',
      group: 'PAYROLL'
    },
    children: [
      {
        path: '/personnel-deduction',
        name: 'deduction',
        component: () => import('@/views/payroll/employee-deduction/index'),
        meta: { title: 'Deductions', group: 'PAYROLLDEDUCTION', icon: 'file-invoice' }
      },
      // {
      //   path: '/deduction-miscellaneous',
      //   name: 'miscellaneous',
      //   component: () => import('@/views/payroll/employee-deduction/miscellaneous'),
      //   meta: { title: 'Miscellaneous', group: 'PAYROLLDEDUCTION', icon: 'file-invoice' }
      // },
      {
        path: '/deduction-miscellaneous',
        name: 'miscellaneous',
        component: () => import('@/views/payroll/employee-deduction/newMiscellaneous'),
        meta: { title: 'Miscellaneous', group: 'PAYROLLDEDUCTION', icon: 'file-invoice' }
      },
      {
        path: '/deduction-overdue',
        name: 'overdue',
        component: () => import('@/views/payroll/employee-deduction/overdue'),
        meta: { title: 'List Overdue', group: 'PAYROLLREPORT', icon: 'file-invoice' }
      },
      {
        path: '/deduction-withoutpay',
        name: 'withoutpay',
        component: () => import('@/views/payroll/employee-deduction/withoutpay'),
        meta: { title: 'Without Pay', group: 'PAYROLLREPORT', icon: 'file-invoice' }
      },
      {
        path: 'personnel-benefits',
        name: 'Benefits',
        component: () => import('@/views/payroll/benefits/index'),
        meta: { title: 'ACA/PERA', group: 'PAYROLLREPORT', icon: 'cart-plus' }
        // PAYROLLBENEFITS
      },
      {
        path: '/post',
        name: 'Post',
        component: () => import('@/views/payroll/ledger/index'),
        meta: { title: 'Post', group: 'PAYROLLREPORT', icon: 'book' }
      },
      {
        path: '/update_post/:year/:month/:status',
        name: 'Update Post',
        hidden: true,
        component: () => import('@/views/payroll/ledger/updateLedger'),
        meta: { title: 'Update Post', group: 'PAYROLLREPORT', icon: 'book' }
      },
      {
        name: 'Reports',
        path: '/payroll-report',
        component: () => import('@/views/payroll/report/index'),
        meta: { title: 'Report', group: 'PAYROLLREPORT', icon: 'flag' }
      },
      {
        path: '/personnelList/:month/:year/:scope/:cnumber/:flag',
        name: 'personnelList',
        hidden: true,
        component: () => import('@/views/payroll/personnel/personnelList'),
        meta: { title: 'Personnel List', group: 'PAYROLLREPORT', icon: 'file-invoice' }
      }
    ]
  },
  // {
  //   path: '/others',
  //   component: Layout,
  //   name: 'Others',
  //   meta: { title: 'Others', group: 'PAYROLLREPORT', icon: 'book-open' },
  //   children: [{
  //     path: '/sp',
  //     name: 'Special Payroll',
  //     component: () => import('@/views/payroll/specialpayroll/index'),
  //     meta: { title: 'Special Payroll', group: 'PAYROLLREPORT', icon: 'book' }
  //   }]
  // },
  {
    path: '/others',
    component: Layout,
    name: 'Others',
    redirect: '/others/sp',
    meta: { title: 'Special Payroll', group: 'PAYROLLREPORT', icon: 'book' },
    children: [
      {
        path: '/sp/posting',
        name: 'Special Payroll Post',
        component: () => import('@/views/payroll/specialpayroll/index'),
        meta: { title: 'Post', group: 'PAYROLLREPORT', icon: 'book' }
      },
      {
        path: '/sp/report',
        name: 'Special Payroll Report',
        component: () => import('@/views/payroll/specialpayroll/report'),
        meta: { title: 'Report', group: 'PAYROLLREPORT', icon: 'flag' }
      },
      {
        path: '/update_post/:year/:month/:cnum/:type/:status',
        name: 'Update Post SP',
        hidden: true,
        component: () => import('@/views/payroll/specialpayroll/updateSPledger'),
        meta: { title: 'Update Post SP', group: 'PAYROLLREPORT', icon: 'book' }
      }
    ]
  },
  {
    path: '/deferential',
    component: Layout,
    redirect: '/deferential-index',
    meta: { group: 'PAYROLLREPORT' },
    children: [{
      name: 'Differential',
      path: '/deferential-index',
      component: () => import('@/views/payroll/deferential/index'),
      meta: { title: 'Differential', group: 'PAYROLLREPORT', icon: 'file-invoice' }
    }]
  },
  {
    path: '/benefits',
    component: Layout,
    redirect: '/personnel-benefits',
    meta: { title: 'Other Benefits', group: 'PAYROLLBENEFITS', icon: 'cart-plus' },
    children: [
    // {
    //   path: 'personnel-honorarium',
    //   name: 'Honorarium',
    //   component: () => import('@/views/payroll/honorarium/index'),
    //   meta: { title: 'Honorarium', group: 'PAYROLLBENEFITS', icon: 'cart-plus' }
    // },
      {
        path: 'personnel-others',
        name: 'OtherBenefits',
        component: () => import('@/views/payroll/honorarium/otherBenefits'),
        meta: { title: 'Benefits', group: 'PAYROLLBENEFITS', icon: 'cart-plus' }
      },
      {
        path: 'other_deduction',
        name: 'OtherBenefitsDeduction',
        component: () => import('@/views/payroll/honorarium/otherBenefitDeduction'),
        meta: { title: 'Deduction', group: 'PAYROLLREPORT', icon: 'cart-plus' }
      },
      {
        path: 'generate-report',
        name: 'ReportOtherBenefits',
        component: () => import('@/views/payroll/honorarium/reportOthers'),
        meta: { title: 'Generate Report', group: 'PAYROLLREPORT', icon: 'cart-plus' }
      }
    ]
  },

  // {
  //   path: '/honorarium',
  //   component: Layout,
  //   redirect: '/personnel-benefits',
  //   meta: { group: 'PAYROLL' },
  //   children: [{
  //     path: '/personnel-honorarium',
  //     name: 'Honorarium',
  //     component: () => import('@/views/payroll/honorarium/index'),
  //     meta: { title: 'Honorarium', group: 'PAYROLL', icon: 'cart-plus' }
  //   }]
  // },
  {
    path: '/remittance',
    component: Layout,
    redirect: '/payroll-remittance',
    meta: { group: 'PAYROLLDEDUCTION' },
    children: [{
      path: '/payroll-remittance',
      name: 'remittance',
      component: () => import('@/views/payroll/remittance/index'),
      meta: { title: 'Remittance', group: 'PAYROLLDEDUCTION', icon: 'file-invoice' }
    }]
  },
  // {
  //   path: '/obligation',
  //   component: Layout,
  //   meta: { group: 'DEFAULT' },
  //   children: [{
  //     path: 'index',
  //     name: 'Obligation',
  //     component: () => import('@/views/payroll/obligation/index'),
  //     meta: { title: 'Obligation', group: 'PAYROLLREPORT', icon: 'file-invoice' }
  //   }]
  // },
  {
    path: '/profile',
    component: Layout,
    meta: { group: 'DEFAULT' },
    children: [{
      path: 'index',
      component: () => import('@/views/profile/index'),
      meta: { title: 'Account Settings', group: 'USERS', icon: 'user-cog' }
    }]
  },
  {
    path: '/setting',
    component: Layout,
    redirect: 'config',
    meta: { title: 'Settings', group: 'PAYROLLSETTING', icon: 'cogs' },
    children: [{
      path: 'config',
      name: 'Settings',
      component: () => import('@/views/payroll/settings/index'),
      meta: { title: 'Settings', group: 'PAYROLLSETTING', icon: 'cogs' }
    },
    {
      path: '/deduction-value/:id',
      name: 'Deduction value',
      hidden: true,
      component: () => import('@/views/payroll/settings/deductionValue'),
      meta: { title: 'Deduction value', group: 'PAYROLLSETTING', icon: 'cogs' }
    }
    ]
  }
]

export default new Router({
  mode: 'history',
  hash: false,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
